import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const MAIN_BANNER_SKELETONS: TSkeletons = [
  {
    className: 'indexBanners__slide',
    height: '420px',
  },
]
